import { commonRequest } from "../../services/ApiCall";
import { Helpers } from "../../services/Helpers";

export const CustomerService = {
    unsortedCustomerList : async (gender,searchKey) =>{
        return await commonRequest("get",  `${Helpers.URL()}/api/admin/customer/customerList?gender=${gender||''}`, {}, Helpers.token());
    },
    sortedCustomerList : async (data,profile) =>{
        console.log("data",data);
        const queryParams = new URLSearchParams();

        // Basic pagination and sorting parameters
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.limit);

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        if (data.filters.sortKey) {
            queryParams.append('sortKey', data.filters.sortKey);            
            queryParams.append('sortDirection', data.filters.sortDirection || 'desc');
        }
        
        // Active or not filters
        queryParams.append('isActive', data.filters?.isActive || '');

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams", queryParams.toString());
        if (profile == 'in-complete') { 
            return await commonRequest("get",  `${Helpers.URL()}/api/admin/customer/incomplete-list?${queryParams.toString()}`, {}, Helpers.token());
        }
        return await commonRequest("get",  `${Helpers.URL()}/api/admin/customer?${queryParams.toString()}`, {}, Helpers.token());
    },

    customerListToExport : async (data,profile) =>{
        console.log("data",data);
        const queryParams = new URLSearchParams();

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        if (data.filters.sortKey) {
            queryParams.append('sortKey', data.filters.sortKey);            
            queryParams.append('sortDirection', data.filters.sortDirection || 'desc');
        }
        
        // Active or not filters
        queryParams.append('isActive', data.filters?.isActive || '');

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams", queryParams.toString());
        if (profile == 'in-complete') { 
            return await commonRequest("get",  `${Helpers.URL()}/api/admin/customer/export-incomplete-list?${queryParams.toString()}`, {}, Helpers.token());
        }
        return await commonRequest("get",  `${Helpers.URL()}/api/admin/customer/export-list?${queryParams.toString()}`, {}, Helpers.token());
    },
    
    addCustomer : async (data) =>{
        return await commonRequest("POST", `${Helpers.URL()}/api/admin/customer/createCustomer`,data, Helpers.token());
    },
    addCustomeraddress : async (data) =>{
        return await commonRequest("POST", `${Helpers.URL()}/api/admin/customer/addCustomerAddress`,data, Helpers.token());
    },
    fetchCustomerDetailById : async (customerId) =>{
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/customer/getCustomerDetails/${customerId}`,{}, Helpers.token());
        // return await commonRequest("GET", `${Helpers.URL()}/api/admin/customer/getCustomerDetails/${customerId}`,{}, Helpers.token());
    },
    fetchCustomerVerificationOtp: async (mobileNumber) => {
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/customer/getVerificationOtp/${mobileNumber}`,{}, Helpers.token());
    },
    fetchBookingHistory : async (customerId) =>{
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/customer/getBookingHistory/${customerId}`,{}, Helpers.token());
    },
    updateCustomerDetails : async (data,customerId) =>{
        return await commonRequest("PUT", `${Helpers.URL()}/api/v2/admin/customer/updateCustomer/${customerId}`,data, Helpers.token());
        // return await commonRequest("PUT", `${Helpers.URL()}/api/admin/customer/updateCustomer/${customerId}`,data, Helpers.token());
    },
    updateCustomerStatus : async (data,customerId) =>{
        return await commonRequest("PUT", `${Helpers.URL()}/api/admin/customer/updateCustomer/${customerId}`,data, Helpers.token());
    },
    verifyCustomerByMobileNo: async (data)=>{
        return await commonRequest("POST", `${Helpers.URL()}/api/v2/admin/customer/verifyCustomerByMobileNo`,data, Helpers.token());
        // return await commonRequest("POST", `${Helpers.URL()}/api/admin/customer/verifyCustomerByMobileNo`,data, Helpers.token());
    },
    verifyMobileNoOtp: async (data)=>{
        return await commonRequest("POST", `${Helpers.URL()}/api/admin/customer/verifyOtp`,data, Helpers.token());
    },

    deleteCustomerById:async (customerId)=>{
        return await commonRequest('DELETE',`${Helpers.URL()}/api/admin/customer/deleteCustomer/${customerId}`,{},Helpers.token()) 
    },
    updateMobileNumber: async (data) =>{
        return await commonRequest('POST',`${Helpers.URL()}/api/admin/customer/changeCustomerMobileNo`,data,Helpers.token());
    },
    sendOtptoVerifyNewNumber: async (data) =>{
        return await commonRequest('POST',`${Helpers.URL()}/api/v2/admin/customer/sendOtpToChangedNumber`,data,Helpers.token());
        // return await commonRequest('POST',`${Helpers.URL()}/api/admin/customer/sendOtpToChangedNumber`,data,Helpers.token());
    },
    addCudelCoins: async (data) =>{
        return await commonRequest('POST',`${Helpers.URL()}/api/admin/payment/addCoinToCustomer`,data,Helpers.token());
    } ,
    getWalletTransactionList: async (data,customerId) =>{
        const queryParams = new URLSearchParams();
        queryParams.append('page', data.page+1);
        queryParams.append('limit', data.pageSize);
        queryParams.append('sortKey', data.filters.sortKey || 'createdAt');
        queryParams.append('sortDirection', data.filters.sortDirection || '');
        return await commonRequest('GET',`${Helpers.URL()}/api/admin/customer/getWalletTransactionHistory/${customerId}?${queryParams.toString()}`,{},Helpers.token());
    },
    modifyIsTesterStatus: async(id) =>{
        return await commonRequest("GET",  `${Helpers.URL()}/api/admin/customer/changeCustomerIsTester/${id}`,{}, Helpers.token());
    },
    fetchLoactionHistory : async(data)=>{
        const queryParams = new URLSearchParams();
        queryParams.append('customerId', data.customerId);
        queryParams.append('page', data.page+1);
        queryParams.append('limit', data.pageSize);
        return await commonRequest('GET',`${Helpers.URL()}/api/admin/customer/customerAddressHistory?${queryParams.toString()}`,{},Helpers.token());  
    },
    updateCustomerDefaultAddress: async(data)=>{
        return await commonRequest('POST',`${Helpers.URL()}/api/admin/customer/update-default-address`,data,Helpers.token());
    },
    registerNewCustomer : async (data) =>{
        return await commonRequest("POST",  `${Helpers.URL()}/api/v2/admin/customer/register/newCustomer`, data, Helpers.token());
    },
    createCustomerProfile : async (data) =>{
        return await commonRequest("POST", `${Helpers.URL()}/api/v2/admin/customer/createCustomer/profile`,data, Helpers.token());
    },
    fetchCustomerAddresses: async (id)=>{
        return await commonRequest('GET',`${Helpers.URL()}/api/v2/admin/customer/getCustomerAllAddresses/${id}`,{},Helpers.token());
    },
    deleteCustomerAddress: async (id)=>{
        return await commonRequest('GET',`${Helpers.URL()}/api/v2/admin/customer/deleteCustomerAddress/${id}`,{},Helpers.token());
    },
}